/**
 * A customer's answer from a place page (core place-votes.ts; place page v4 item 22; PLACE_VOTES): the page links to
 * …/app/vote?place=<key>&item=<id>&kind=useful|true&v=up|down. Kept the moment the app loads (like the fix and go intents), so the sign-in
 * can't lose it; sent once the person is signed in (App.tsx VoteHost), then cleared. Only a well-formed answer is kept (core voteFrom), for an hour.
 */
import { voteFrom, VOTE_PATH, type VoteInput } from "@logwave/core";

export const VOTE_KEY = "cc.vote.pending";
const TTL_MS = 3_600_000;
function safeStorage(): Storage | undefined {
  try { return typeof localStorage === "undefined" ? undefined : localStorage; } catch { return undefined; }
}
let memory: (VoteInput & { at: string }) | null = null;

/** A visit to /app/vote with an answer: keep it. */
export function captureVote(path: string, search: string, storage: Storage | undefined = safeStorage(), now = new Date()): VoteInput | null {
  if (path.replace(/\/+$/, "") !== VOTE_PATH) return null;
  const v = voteFrom(Object.fromEntries(new URLSearchParams(search)));
  if (!v) return null;
  memory = { ...v, at: now.toISOString() };
  try { storage?.setItem(VOTE_KEY, JSON.stringify(memory)); } catch { /* this page load only */ }
  return v;
}
export function pendingVote(storage: Storage | undefined = safeStorage(), now = new Date()): VoteInput | null {
  let v: Record<string, unknown> | null = memory ? { ...memory } : null;
  try { const raw = storage?.getItem(VOTE_KEY); if (raw) v = JSON.parse(raw) as Record<string, unknown>; } catch { /* memory */ }
  if (!v || typeof v.at !== "string" || now.getTime() - Date.parse(v.at) > TTL_MS) return null;
  return voteFrom(v);
}
export function clearVote(storage: Storage | undefined = safeStorage()): void {
  memory = null;
  try { storage?.removeItem(VOTE_KEY); } catch { /* ignore */ }
}
